import useUser from '@hooks/auth/useUser';
import type { RegisteredActivityName } from '@stackflow/config';
import { useFlow } from '@stackflow/react';
import classNames from 'classnames/bind';
import { ReactNode } from 'react';

import styles from './styles.module.scss';

const cx = classNames.bind(styles);

export interface AuthFlow {
    activityName: RegisteredActivityName,
    activityParams: object,
}

interface Props {
    children: ReactNode;
    className?: string,
    flows?: AuthFlow[],
}

function AuthGuard({ children, className, flows }: Props) {
    const { user } = useUser();
    const { push } = useFlow();
    return (
        <div className={`${cx({
            wrapper: true,
            none: !user,
        })} ${className}`}
        onClick={(e) => {
            if (!user) {
                e.preventDefault();
                e.stopPropagation();
                push('SignInActivity', { flows });
            }
        }} >
            {children}
        </div>
    );
}

export default AuthGuard;
